import Cookies from 'js-cookie';
import { getLanguage } from '@/lang/index';
var state = {
  sidebar: {
    opened: Cookies.get('sidebarStatus') ? !!+Cookies.get('sidebarStatus') : true,
    withoutAnimation: false
  },
  menuSearchKey: '',
  // 菜单搜索关键字
  menuExpanded: {},
  // 菜单展开状态：{ [path]: true/false }
  menuOpeneds: [],
  // 存储当前展开的主菜单index
  device: 'desktop',
  language: getLanguage(),
  size: Cookies.get('size') || 'medium'
};
var mutations = {
  TOGGLE_SIDEBAR: function TOGGLE_SIDEBAR(state) {
    state.sidebar.opened = !state.sidebar.opened;
    state.sidebar.withoutAnimation = false;
    if (state.sidebar.opened) {
      Cookies.set('sidebarStatus', 1);
    } else {
      Cookies.set('sidebarStatus', 0);
    }
  },
  CLOSE_SIDEBAR: function CLOSE_SIDEBAR(state, withoutAnimation) {
    Cookies.set('sidebarStatus', 0);
    state.sidebar.opened = false;
    state.sidebar.withoutAnimation = withoutAnimation;
  },
  TOGGLE_DEVICE: function TOGGLE_DEVICE(state, device) {
    state.device = device;
  },
  SET_LANGUAGE: function SET_LANGUAGE(state, language) {
    state.language = language;
    Cookies.set('language', language);
  },
  SET_SIZE: function SET_SIZE(state, size) {
    state.size = size;
    Cookies.set('size', size);
  },
  SET_MENU_SEARCH_KEY: function SET_MENU_SEARCH_KEY(state, key) {
    state.menuSearchKey = key;
  },
  SET_MENU_EXPANDED: function SET_MENU_EXPANDED(state, _ref) {
    var path = _ref.path,
      expanded = _ref.expanded;
    state.menuExpanded[path] = expanded;
  },
  SET_MENU_OPENEDS: function SET_MENU_OPENEDS(state, openeds) {
    state.menuOpeneds = openeds;
  }
};
var actions = {
  toggleSideBar: function toggleSideBar(_ref2) {
    var commit = _ref2.commit;
    commit('TOGGLE_SIDEBAR');
  },
  closeSideBar: function closeSideBar(_ref3, _ref4) {
    var commit = _ref3.commit;
    var withoutAnimation = _ref4.withoutAnimation;
    commit('CLOSE_SIDEBAR', withoutAnimation);
  },
  toggleDevice: function toggleDevice(_ref5, device) {
    var commit = _ref5.commit;
    commit('TOGGLE_DEVICE', device);
  },
  setLanguage: function setLanguage(_ref6, language) {
    var commit = _ref6.commit;
    commit('SET_LANGUAGE', language);
  },
  setSize: function setSize(_ref7, size) {
    var commit = _ref7.commit;
    commit('SET_SIZE', size);
  }
};
export default {
  namespaced: true,
  state: state,
  mutations: mutations,
  actions: actions
};